import { useAxesTooltip } from '@mui/x-charts/ChartsTooltip';
import { formatNumber } from '@vy/utils';
import { REPORT_CHART_COLORS } from '../../../reports-components/chart-theme';
import {
  ReportChartTooltipFrame,
  ReportChartTooltipRow,
} from '../../../reports-components/ReportChartTooltip';

const BREAKDOWN_ROWS = [
  { id: 'recognized', label: 'Recognized', color: REPORT_CHART_COLORS.recognized },
  { id: 'deferred', label: 'Deferred', color: REPORT_CHART_COLORS.deferred },
  { id: 'unbilled', label: 'Unbilled', color: REPORT_CHART_COLORS.unbilled },
];

export const CustomerRevenueReportChartTooltip: React.FC = () => {
  const tooltipData = useAxesTooltip();
  if (!tooltipData || tooltipData.length === 0) return null;

  const { axisValue, seriesItems } = tooltipData[0];

  const seriesById = new Map(seriesItems.map((item) => [item.seriesId, item]));

  const formatSeriesValue = (seriesId: string): string => {
    const item = seriesById.get(seriesId);
    if (!item || typeof item.value !== 'number') return '--';
    return formatNumber(item.value, 0);
  };

  return (
    <ReportChartTooltipFrame title={String(axisValue)}>
      {BREAKDOWN_ROWS.map(({ id, label, color }) => (
        <ReportChartTooltipRow
          key={id}
          color={color}
          label={label}
          formattedValue={formatSeriesValue(id)}
        />
      ))}
    </ReportChartTooltipFrame>
  );
};
